import { render } from "./ViewTypeFu.vue?vue&type=template&id=65925deb&scoped=true"
import script from "./ViewTypeFu.vue?vue&type=script&lang=js"
export * from "./ViewTypeFu.vue?vue&type=script&lang=js"

import "./ViewTypeFu.vue?vue&type=style&index=0&id=65925deb&lang=scss&scoped=true"

import exportComponent from "/opt/buildhome/repo/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-65925deb"]])

export default __exports__